// extracted by mini-css-extract-plugin
export default {"Features":"Features_Features__+-1UV","Features__heading":"Features_Features__heading__geyaD","Features__heading__logo":"Features_Features__heading__logo__8SEG-"};